import { Observable } from "rxjs";

import { DataStoreOptions, SearchQuery, SearchResponse, ThesaurusTerm } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { ThesaurusTermDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, ThesaurusTermOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const THESAURUS_TERMS_TO_CACHE

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.thesaurusTerm ?? config.syncDownPageSize.default

export class ThesaurusTermSyncDownHandler extends EntitySyncDownHandler<ThesaurusTerm, ThesaurusTerm, ThesaurusTerm> {
    private static instance: ThesaurusTermSyncDownHandler = null as any

    public static getInstance() {
        if (!ThesaurusTermSyncDownHandler.instance) {
            ThesaurusTermSyncDownHandler.instance = new ThesaurusTermSyncDownHandler()
        }

        return ThesaurusTermSyncDownHandler.instance
    }

    public static install(Vue) {
        ThesaurusTermSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.thesaurusTerm],
            ThesaurusTermDataStore.getInstance(),
            new ThesaurusTermOfflineDataFetcher(),
            CACHE_KEYS.ThesaurusTerm,
            SEARCH_PAGE_SIZE
        )
    }

    sendSynchroDownRequest(searchQuery: SearchQuery, options: DataStoreOptions): Observable<SearchResponse<ThesaurusTerm>> {
        let updatedSearchQuery: SearchQuery = {...searchQuery}

        updatedSearchQuery.constraints = [
            (this.dataStore as ThesaurusTermDataStore).getFilterUnimarcCriteria(false)
        ]

        if(!searchQuery.advancedSearches && THESAURUS_TERMS_TO_CACHE) {
            updatedSearchQuery.advancedSearches = this.buildThesauriContentRetrievalCacheRequest(THESAURUS_TERMS_TO_CACHE)
        }

        return this.dataStore.paginatedSearch(updatedSearchQuery, options)
    } 

    private buildThesauriContentRetrievalCacheRequest(thesaurusIds: string[]) {
        let advancedSearch: any[] = []

        if(thesaurusIds && thesaurusIds.length) {
            const firstThesaurusId = thesaurusIds.shift()

            let genericTermRes: any = {
                entityField: '59cb956f326d470001a93b3b',
                operator: 'equals',
                type: 'criteria',
                value: {
                    completeSearch: false,
                    refId: firstThesaurusId,
                    type: 'ref'
                }
            }

            let thesaurusFieldRes: any = {
                entityField: '59cb956f326d470001a93b3c',
                operator: 'equals',
                type: 'criteria',
                value: {
                    completeSearch: false,
                    refId: firstThesaurusId,
                    type: 'ref'
                }
            }

            for(let thesaurusId of thesaurusIds) {
                genericTermRes = this.buildThesaurusTermAdvancedSearchCriteria('59cb956f326d470001a93b3b', genericTermRes, thesaurusId)
                thesaurusFieldRes = this.buildThesaurusTermAdvancedSearchCriteria('59cb956f326d470001a93b3c', thesaurusFieldRes, thesaurusId)
            }

            const finalResult = {
                leftCriteria: thesaurusFieldRes,
                linkOperator: 'OR',
                rightCriteria: genericTermRes,
                type: 'requestSearch'
            }

            advancedSearch.push(finalResult)
        }

        return advancedSearch
    }

    private buildThesaurusTermAdvancedSearchCriteria(entityField: string, previous: any, refId: string) {
        return {
            leftCriteria: previous,
            linkOperator: 'OR',
            rightCriteria: {
                entityField: entityField,
                operator: 'equals',
                type: 'criteria',
                value: {
                    completeSearch: false,
                    refId: refId,
                    type: 'ref'
                }
            },
            type: 'requestSearch'
        }
    }
}